import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class ButtonLoaderStateService {
  private state: Subject<boolean>;
  private withUrls: { [key: string]: boolean } = {};
  private stateWithIndex: Subject<{ [key: string]: boolean }>;

  constructor() {
    this.state = new Subject<boolean>();
    this.stateWithIndex = new Subject<{ [key: string]: boolean }>();
  }

  get loaderState() {
    return this.state.asObservable();
  }

  get loaderStateWithIndex() {
    return this.stateWithIndex.asObservable();
  }

  startLoader(url: string) {
    this.withUrls[url] = true;
    this.stateWithIndex.next(this.withUrls);
    this.state.next(true);
  }

  stopLoader(url: string) {
    this.withUrls[url] = false;
    this.stateWithIndex.next(this.withUrls);
    this.state.next(false);
  }
}
